import { CaseListType } from "DataTypes/Case.type";
import { CheckArr, CheckStringEmpty } from "Utils/Common";
import { CheckNumber } from "./../../../../../Utils/Common";

export const FormateCaseList: (res: any) => CaseListType[] = (res) => {
  const newArr = CheckArr(res);
  return newArr?.map((el) => {
    return {
      caseId: CheckNumber(el?.pkCase),
      orderTypeId: CheckNumber(el?.orderTypeId),
      clientId: CheckNumber(el?.clientId),
      clientFullName: CheckStringEmpty(el?.clientFullName),
      caseType: CheckStringEmpty(el?.caseTypeName),
      orderType: CheckStringEmpty(el?.orderTypeName),
      casePrice: CheckNumber(el?.casePrice),
      currentProcessingStatusName: CheckStringEmpty(
        el?.currentProcessingStatusName
      ),
      dateCreated: CheckStringEmpty(el?.dateCreated),
      statusLastUpdated: CheckStringEmpty(el?.statusLastUpdated),
      assignedProfessionalName: CheckStringEmpty(el?.assignedProfessionalName),
      description: CheckStringEmpty(el?.description),
      clientOrganizationName: CheckStringEmpty(el?.clientOrganizationName),
      clientUserType: CheckStringEmpty(el?.clientUserType),
    };
  });
};
